import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import HorizontalBarChart from '@/components/charts/HorizontalBarChart';
import { REPORTS_COLORS } from '@/constants/chartcolors.constants';
import { YEAR_MONTH_DAY_FORMAT } from '@/constants/date.constants';
import { useFetchCaseMetrics } from '@/pages/Dashboard/DashboardCases/DashboardCases.store';
import { REPORTS_ALERTS_HORIZONTAL_BAR_SERIES } from '@/pages/ReportsTemplates/ReportsTemplates.constants';
import { sortAndTruncateData } from '../../ReportsTemplate.utils';
import useStyles from '../ReportsPages.styles';

const NetworkCasesGraph = () => {
  const { classes } = useStyles();

  const organizationLabel =
    new URLSearchParams(window.location.search).get('organization') ?? 'pontst'; // Get organization from URL
  const startDate =
    new URLSearchParams(window.location.search).get('start') ?? '2024-12-01'; // Get startDate from URL
  const endDate =
    new URLSearchParams(window.location.search).get('end') ?? '2024-12-31'; // Get endDate from URL
  const startAndEndDateDiff = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;

  const minimumStartDate =
    startAndEndDateDiff < 7
      ? dayjs(startDate)
          .subtract(7 - startAndEndDateDiff, 'day')
          .format('YYYY-MM-DD')
      : startDate; // Minimum date difference for graphs over timeframes less than 7 days

  const inclusiveEndDate = dayjs(endDate)
    .add(1, 'day')
    .format(YEAR_MONTH_DAY_FORMAT); // Adding 1 day to include the whole end date

  const { data: casesPerDay } = useFetchCaseMetrics({
    created_at: { from_date: minimumStartDate, to_date: inclusiveEndDate },
    group_by: 'host',
    case_type: 'network',
    organization_label: organizationLabel
  });

  const networkSensorBarGraphData = () => {
    const sortedNetworkData = sortAndTruncateData(
      casesPerDay,
      10,
      'network_count'
    );
    return sortedNetworkData.map((item) => {
      const name = item.value;
      const data = item.network_count;
      return { name, count: data, color: REPORTS_COLORS.CASES };
    });
  };

  return (
    <>
      <Typography className={classes.reportsPreviewSubTitle}>
        Top Network Cases by Sensor
      </Typography>
      <HorizontalBarChart
        height={250}
        data={networkSensorBarGraphData()}
        series={REPORTS_ALERTS_HORIZONTAL_BAR_SERIES}
      />
    </>
  );
};

export default NetworkCasesGraph;
